import {defineStore} from 'pinia'

type EventHandler = () => void

export const useIamEventsStore = defineStore('iam-events', () => {
  const rolesListSubscribers = new Set<EventHandler>()
  const clientsListSubscribers = new Set<EventHandler>()
  const principalsListSubscribers = new Set<EventHandler>()

  function subscribeToRolesList(handler: EventHandler) {
    rolesListSubscribers.add(handler)
    return () => rolesListSubscribers.delete(handler) // Unsubscribe function
  }

  function subscribeToClientsList(handler: EventHandler) {
    clientsListSubscribers.add(handler)
    return () => clientsListSubscribers.delete(handler)
  }

  function subscribeToPrincipalsList(handler: EventHandler) {
    principalsListSubscribers.add(handler)
    return () => principalsListSubscribers.delete(handler)
  }

  function emitRolesListChanged() {
    rolesListSubscribers.forEach(handler => handler())
  }

  function emitClientsListChanged() {
    clientsListSubscribers.forEach(handler => handler())
  }

  function emitPrincipalsListChanged() {
    principalsListSubscribers.forEach(handler => handler())
  }

  return {
    subscribeToRolesList,
    subscribeToClientsList,
    subscribeToPrincipalsList,
    emitRolesListChanged,
    emitClientsListChanged,
    emitPrincipalsListChanged,
  }
})
